import { IntegratedHealthHero } from '@/components/integrated-health/IntegratedHealthHero'
import { IntegratedHealthPricing } from '@/components/integrated-health/IntegratedHealthPricing'
import { IntegratedHealthDetails } from '@/components/integrated-health/IntegratedHealthDetails'
import { IntegratedHealthIncluded } from '@/components/integrated-health/IntegratedHealthIncluded'
import { IntegratedHealthNotes } from '@/components/integrated-health/IntegratedHealthNotes'

export const IntegratedHealthPage = () => (
  <>
    <IntegratedHealthHero />

    <IntegratedHealthPricing />

    <IntegratedHealthDetails />

    <IntegratedHealthIncluded />

    <IntegratedHealthNotes />
  </>
)
